module.exports = __webpack_public_path__ + "img/nav-issues.b92243a0.svg";